import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "../../../services/api/axios";

const fetchConsumerPayoutMethods = async (search, currencyCode) => {
  const params = {};
  if (search) params.search = search;
  if (currencyCode) params.currencyCode = currencyCode;
  const response = await api.get("/v1/admin/personal/payout-methods", {
    params: Object.keys(params).length ? params : undefined,
  });
  return response.data;
};

export const useConsumerPayoutMethods = (search, currencyCode) => {
  return useQuery({
    queryKey: ["consumer-payout-methods", search, currencyCode],
    queryFn: () => fetchConsumerPayoutMethods(search, currencyCode),
    refetchOnWindowFocus: false,
  });
};

const updateConsumerPayoutMethod = async ({ uuid, payload }) => {
  const { data } = await api.patch(
    `/v1/admin/personal/payout-methods/${uuid}`,
    payload
  );
  return data;
};

export const useUpdateConsumerPayoutMethod = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateConsumerPayoutMethod,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["consumer-payout-methods"] });
    },
  });
};

// Runs the sync with the business side now. With a country it finishes and
// returns what changed; without one it starts in the background.
const syncConsumerPayoutMethods = async (countryCode) => {
  const { data } = await api.post(
    "/v1/admin/personal/payout-methods/sync",
    {},
    { params: countryCode ? { countryCode } : undefined, timeout: 60000 }
  );
  return data;
};

export const useSyncConsumerPayoutMethods = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: syncConsumerPayoutMethods,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["consumer-payout-methods"] });
    },
  });
};
